/** Structural counter data (locale-free). Copy lives in locales/{locale}/counter.json */
export const COUNTER_LIST_TWO_STRUCTURE = [
  { id: 1, count: 98, suffix: "%" },
  { id: 2, count: 2, suffix: "k" },
  { id: 3, count: 3, suffix: "k" },
  { id: 4, count: 5, suffix: "k" },
];

export const getCounterListTwo = (t) =>
  COUNTER_LIST_TWO_STRUCTURE.map((item) => {
    const copy = t(String(item.id), { ns: "counter", returnObjects: true });
    return {
      ...item,
      ...(copy && typeof copy === "object" ? copy : {}),
    };
  });

/** @deprecated Prefer getCounterListTwo(t) */
export const COUNTER_LIST_TWO = COUNTER_LIST_TWO_STRUCTURE;
